import React from 'react';
import styled from 'styled-components/macro';
import { ReactSVG } from 'react-svg';

import spinner from 'images/spinner.svg';


const Spinner = (props) => (
    <Container {...props}>
        <ReactSVG src={spinner}/>
    </Container>
);


export default Spinner;


const Container = styled.span`
    display: inline-block;
    vertical-align: middle;
    height: 1em;
    line-height: 1em;
    
    div {
        height: 100%;
    }
    
    svg {
        height: 100%;
        width: auto;
        stroke: ${props => props.theme.secondary_color};
    }
`;
